import {generateRequest} from 'fallco-frontend-framework/src/js/classes/HttpManager/api_utilities.js';

const END_POINT = 'notifiche';

const getNotifiche = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "get_notifiche" , data: params}, callback);
const setNotificaLetta = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "set_read" , data: params}, callback);
const setTutteNotificheLette = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "set_read" , data: params}, callback);

const apiEndpoint = {
  getNotifiche,
  setNotificaLetta,
  setTutteNotificheLette
}

export default apiEndpoint;